import pagination from '@iso/lib/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('users');

const actions = {
    requestFetchUsers: baseActions.request,
    fetchUsersSucceeded: baseActions.succeeded,
    fetchUsersFailed: baseActions.failed,
};

export { types, actions };

export default reducer;